export class DemographicReportUrls {

	public static DOWNLOAD_DETAIL_REPORT = '/api/v1/demographicreport/downloaddetailreport';
	public static DOWNLOAD_COUNTY_REPORT = '/api/v1/demographicreport/downloadcountyreport';
	public static DOWNLOAD_ZIPCODE_REPORT = '/api/v1/demographicreport/downloadzipcodereport';
	public static DOWNLOAD_SUMMARY_REPORT = '/api/v1/demographicreport/downloadsummaryreport';

}
